export default {
      id: "txt_blockquote-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_blockquote",
      toString: function () {
        return this.url;
      }
    }